import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { cdnUrl } from "@Utils/cdnHelper";
import './style.css';

class Loader extends Component {
  render() {
    const { loaderCount = 0 } = this.props;
    return (
      <Fragment>
        {loaderCount > 0 && (
          <div className="loaderContainer">
            <img src={cdnUrl("loader.gif", "images")} alt="loading icon" />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({LoaderReducers}) => ({
  loaderCount: LoaderReducers.loaderCount,
});
export default connect(mapStateToProps)(Loader);
